import React from 'react'
import {Box,Text} from 'grommet';
import { Alert } from 'grommet-icons';


function ShipmentQuoteTotal(props){
    if (props.billing){
        return(
            <Box direction='row' margin={'small'}>
                <Text weight='bold' margin={{left:'small'}}>Total Bill: ${props.shipment.total_billing_price} {props.shipment.total_billing_price_currency}</Text>
            <Box direction='row' margin='small' justify='center'>
                
            </Box>
            </Box>
        )
    } else {
        return(
            <Box direction='row' margin={'small'}>
                <Text weight='bold' margin={{left:'small'}}>Quote: ${props.shipment.quote.total_quote_price} {props.shipment.quote.total_quote_price_currency}</Text><Alert color='status-critical' style={{marginLeft: 7, marginBottom:7}}/>
                <Text size='xsmall' margin={{left:'xsmall', top:'xsmall'}}>Please note this is an approximate quote and the final total may be subject to additional duties and taxes.</Text>
            <Box direction='row' margin='small' justify='center'>
                
            </Box>
            </Box>
        )
    }
   
  }


  export default ShipmentQuoteTotal